import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { AlarmClockIcon, LockIcon } from "lucide-react";
import { useOffer } from "../contexts/OfferContext";
import { useScrollProgressReveal } from "../hooks/useScrollProgressReveal";
import { FUTURE_PRICE, PRICE_TODAY } from "../data/offer";
export function StickyBar() {
  const {
    minutes,
    seconds,
    stock,
    soldPercent,
    dateLabel,
    shortDate
  } = useOffer();
  const visible = useScrollProgressReveal(0.5);
  return <AnimatePresence data-id="element-537" data-mp="jv0w0nkrr4ch">
      {visible && <motion.div initial={{
      y: "-100%"
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 top-0 z-50 border-b border-gold/30 bg-cocoa-dark text-cream shadow-[0_8px_24px_-8px_rgba(0,0,0,0.5)]" data-id="element-538" data-mp="ju7vi4celb2s">
          <div className="mx-auto flex max-w-7xl flex-col gap-2 px-3 py-2 sm:px-6 lg:flex-row lg:items-center lg:gap-6" data-id="element-539" data-mp="298mhigw1ejul">
            <div className="flex items-center justify-between gap-3 text-xs sm:text-sm lg:justify-start" data-id="element-540" data-mp="248rnw5kvng5u">
              <p className="flex items-center gap-1.5 font-bold" data-id="element-541" data-mp="3ih38ti4nb612">
                <motion.span animate={{
              rotate: [0, -14, 14, -10, 0]
            }} transition={{
              duration: 0.6,
              repeat: Infinity,
              repeatDelay: 2.4
            }} className="inline-flex" data-id="element-542" data-mp="3mhdfyy46c2hi">
                  <AlarmClockIcon className="h-4 w-4 text-gold-light" data-id="element-543" data-mp="3dhqpv8gwaj3r" />
                </motion.span>
                <span className="uppercase tracking-wide" data-id="element-544" data-mp="52gh5hii2fn0">
                  <span className="hidden sm:inline" data-id="element-545" data-mp="9xvtu64ru5hu">Lanzamiento exclusivo hoy</span>
                  <span className="sm:hidden" data-id="element-546" data-mp="3renfj6la1uj2">Exclusivo hoy</span>
                </span>
                <span className="text-gold-light" data-id="element-547" data-mp="8lzskqdacr3">
                  <span className="hidden md:inline" data-id="element-548" data-mp="7auggh9wwxv">· {dateLabel}</span>
                  <span className="md:hidden" data-id="element-549" data-mp="ny6mnepn5u5n">· {shortDate}</span>
                </span>
              </p>
              <p className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-550" data-mp="sr9e9hauytj7">
                <span className="hidden sm:inline" data-id="element-551" data-mp="12km209lj4ue9">95% OFF termina en</span>
                <span className="sm:hidden" data-id="element-552" data-mp="xmu0qoyzvvxe">Termina en</span>
                <span className="rounded-md bg-berry px-2 py-0.5 font-mono text-sm font-bold tabular" data-id="element-553" data-mp="xndkmb87gue2">
                  {minutes}:{seconds}
                </span>
              </p>
            </div>

            <div className="flex flex-1 items-center gap-2 sm:gap-3" data-id="element-554" data-mp="olm9uryt5xdc">
              <p className="whitespace-nowrap text-xs" data-id="element-555" data-mp="jnkvgkcbum87">
                Quedan <b className="text-sm text-gold-light tabular" data-id="element-556" data-mp="ewckhjvcmssx">{stock}</b>
                <span className="hidden sm:inline" data-id="element-557" data-mp="eu9kq84e9lb0"> descargas</span>
              </p>
              <span className="rounded bg-gold-light px-1.5 py-0.5 text-xs font-extrabold text-cocoa-dark" data-id="element-558" data-mp="9x9e9w3mugjd">${PRICE_TODAY}</span>
              <div className="relative h-3 flex-1 overflow-hidden rounded-full bg-white/10 ring-1 ring-white/10" aria-label={`${soldPercent}% vendido`} data-id="element-559" data-mp="wbig13clfbv">
                <motion.div className="bg-stripes animate-stripes h-full rounded-full bg-berry" initial={{
              width: 0
            }} animate={{
              width: `${soldPercent}%`
            }} transition={{
              duration: 0.3,
              ease: "easeOut"
            }} data-id="element-560" data-mp="3s34kt89vnkhz" />
              </div>
              <span className="flex items-center gap-0.5 text-xs font-bold text-cream/40" data-id="element-561" data-mp="2gm1kqqibuops">
                <LockIcon className="h-3 w-3" data-id="element-562" data-mp="2ljjz4wf45w56" />${FUTURE_PRICE}
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}